import { ChangeDetectorRef, Component, Inject, OnDestroy, Optional, ViewChild, ViewRef } from '@angular/core';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import _ from 'lodash';
import moment from 'moment';
import { ApiQuery } from '../../../web-services/api/api.query';
import { ApiService } from '../../../web-services/api/api.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResponsiveService } from '../../../services/responsive.service';
import { TranslatorService } from '../../../services/translator_service';
import { ApiStore } from '../../../web-services/api/api.store';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { Subject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { PaginationComponent } from '../../pagination/pagination.component';
import { UtilService } from '../../../services/util.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-force-bin-collection-modal',
  standalone: true,
  imports: [TranslateModule, RTLDivDirectiveDirective,CommonModule,FormsModule,MatFormFieldModule,MatInputModule,
    NgbModule,ReactiveFormsModule,MatTableModule,MatSortModule,MatCheckboxModule,MatTabsModule,
    PaginationComponent],
  templateUrl: './force-bin-collection-modal.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
      ])
    ],
  styleUrl: './force-bin-collection-modal.component.scss'
})
export class ForceBinCollectionModalComponent {
	expandedElement: any;
	currentLang;
	translationsObj;
	isMobile: Boolean;
  	tempFilter = '';
	dataSource = new MatTableDataSource<any>();
	dataSourceMobile = new MatTableDataSource<any>([]);
	dataSourceAddBins = new MatTableDataSource<any>();
	dataSourceAddBinsMobile = new MatTableDataSource<any>([]);
  	addBinsTable : Array<object> = [];
	binsDataTable : Array<object> = [];
	binsData;
	binsDataAddBins;
	displayedColumns = ['select', 'name', 'address','neighborhood','status','collection_mode','predicted_time_for_max_allowed_capacity'];
	displayedColumnsMobile = ['select', 'name', 'address', 'arrowDown'];
	selectionAddBins= new SelectionModel<Element>(true, []);
	selection = new SelectionModel<Element>(true, []);
	@ViewChild(MatSort,{static: false}) sort: MatSort;
	ElForm: FormGroup;
	siteList:Array<object>;
	allBinsForChoose: any;
	allBinsToCollect:any;
	allBinsForChooseBackUp:Array<object> = [];
	allBinsToCollectBackUp:Array<object> = [];
	is_view_unexecuted_work_plans:any = 0;
	usageType = 1;
	filteredData:Array<object> = [];
	filteredBinsToCollectData:Array<object> = [];
	startIndexTableDataAllBins = 0;
	endIndexTableDataAllBins = 7;
	startIndexTableData = 0;
	endIndexTableData = 7;
	private readonly destroy$ = new Subject<void>();
	spinnerActive:boolean = false;
	selectedTab:number = 0;
	max_capacity_in_bins = 0;
	private readonly preselectedBinsFromMap: any[] | null;

  constructor(private responsiveService: ResponsiveService,public fb: FormBuilder,private apiService:ApiService,
    private apiStore:ApiStore,private translator: TranslatorService,private apiQuery:ApiQuery,private cd: ChangeDetectorRef,
	private dialogRef: MatDialogRef<ForceBinCollectionModalComponent>,private utilService: UtilService,
	@Optional() @Inject(MAT_DIALOG_DATA) dialogData: { preselectedBins?: any[] } | null) {
		this.preselectedBinsFromMap = dialogData?.preselectedBins?.length ? dialogData.preselectedBins : null;
		this.dialogRef.disableClose = true;
		this.translator.currentLangEmitter$
		.pipe(takeUntil(this.destroy$))
		.subscribe(async value=>{						
		this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
		this.currentLang = this.translator.getTranslationLanguage();	   
		})
		this.ElForm = this.fb.group({
			siteName: '',
		});
	}

  ngOnInit() {
    this.onResize();
	this.responsiveService.checkWidth();
	this.apiQuery.user$.pipe(takeUntil(this.destroy$)).subscribe(user => {
		if (!user) return;

		if(user["usage_type_id"] != 1){
			this.usageType = user["usage_type_id"];
		}
		this.is_view_unexecuted_work_plans = user["is_view_unexecuted_work_plans"];			
	});
	this.apiQuery.sitesListData$.pipe(takeUntil(this.destroy$)).subscribe((sitesList) => {
		if(sitesList == null || sitesList.length == 0){return;}
		this.siteList = sitesList;

		this.siteList.sort(function(a, b){
			if(a["site_name"] < b["site_name"]) { return -1; }
			if(a["site_name"] > b["site_name"]) { return 1; }
			return 0;
		});
		if(this.siteList.length == 1){
			this.ElForm.controls["siteName"].setValue(this.siteList[0]["site_id"]);
			this.getSiteChosen();
		} else if (this.preselectedBinsFromMap?.length) {
			const siteIds = [...new Set(this.preselectedBinsFromMap.map((b: any) => b.site_id))];
			if (siteIds.length === 1) {
				this.ElForm.controls["siteName"].setValue(siteIds[0]);
				this.getSiteChosen();
			}
		}
	})
  }
  
	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		if (!this.cd['destroyed'] || !(this.cd as ViewRef).destroyed) {			
			this.cd.detectChanges();
		}
	}
  
  onResize() {
		this.responsiveService.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}

	getSiteChosen(){
		this.apiQuery.filteredBins$.pipe(takeUntil(this.destroy$)).subscribe(bins => {	
			this.spinnerActive = true;
			if(bins.length == 0) return;
			this.spinnerActive = false;					
			let allBinsToCollect = bins.filter(bin => {
				return (bin["site_id"] == this.ElForm.getRawValue()['siteName'] && bin["is_forced_to_work_plan"] == 1);
			});	
			let allBinsForChoose = bins.filter(bin => {
				return (bin["site_id"] == this.ElForm.getRawValue()['siteName'] && bin["is_forced_to_work_plan"] == 0);
			});	

			this.allBinsToCollectBackUp = allBinsToCollect;
			this.allBinsForChooseBackUp = allBinsForChoose;

			this.allBinsToCollect = allBinsToCollect;
			this.allBinsForChoose = allBinsForChoose;
			this.initializeAddBinsTable();
			this.initializeBinsTable();
			this.applyPreselectedBinsFromMap();
			this.selection.clear();
			this.selectionAddBins.clear();
			this.cd.detectChanges();
		});

		this.apiQuery.filteredTrucks$.pipe(takeUntil(this.destroy$)).subscribe(trucks => {
			this.max_capacity_in_bins = 0;
			_.each(trucks, (truck) => {
				if(truck["site_id"] == this.ElForm.getRawValue()['siteName']){
					this.max_capacity_in_bins += truck["max_capacity_in_bins"];
				}
			});		
		});
	}

	myTabSelectedIndexChange(event){
		this.selectedTab = event;
	}

	private applyPreselectedBinsFromMap(): void {
		if (!this.preselectedBinsFromMap?.length) {
			return;
		}
		const siteId = this.ElForm.getRawValue()['siteName'];
		if (siteId === '' || siteId === null || siteId === undefined) {
			return;
		}
		const wantIds = new Set(
			this.preselectedBinsFromMap
				.filter((b: any) => String(b.site_id) === String(siteId))
				.map((b: any) => b.bin_id)
		);
		if (wantIds.size === 0) {
			return;
		}
		const toMove = this.allBinsForChoose.filter((b: any) => wantIds.has(b.bin_id));
		if (toMove.length === 0) {
			return;
		}
		const moveIds = new Set(toMove.map((b: any) => b.bin_id));
		this.allBinsToCollect = [...this.allBinsToCollect, ...toMove];
		this.allBinsForChoose = this.allBinsForChoose.filter((b: any) => !moveIds.has(b.bin_id));
		this.initializeBinsTable();
		this.initializeAddBinsTable();
	}
  
	closeModal = () => {
		this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
		this.dialogRef.close();
	}

	onAllBinsTablePageChange = (dataTableIndexes: any) => {
		this.startIndexTableDataAllBins = dataTableIndexes.startIndex;
		this.endIndexTableDataAllBins = dataTableIndexes.endIndex;
		this.updateAddBinsTableDataMobile();
	}

	onTablePageChange = (dataTableIndexes: any) => {
		this.startIndexTableData = dataTableIndexes.startIndex;
		this.endIndexTableData = dataTableIndexes.endIndex;
		this.updateTableDataMobile();
	}

	masterToggle = () => {		
		this.isAllSelected() ?
			this.selection.clear() :
			this.dataSource["AllData"].filteredData.map(row =>
				this.selection.select(row))
	}

	isAllSelected = (): boolean => {
		const numSelected = this.selection.selected.length;
		const numRows = this.dataSource["AllData"].filteredData.length;
		return numSelected === numRows;
	}

	private updateAddBinsTableData(): void {
		const tempSearch = new MatTableDataSource<any>(this.addBinsTable || []);
		tempSearch.filter = this.tempFilter;
		this.filteredData = tempSearch.filteredData;
		this.dataSourceAddBins = tempSearch.filteredData.length > 0 ?
			new MatTableDataSource<any>(tempSearch.filteredData) : new MatTableDataSource<any>([]);
	}

	private updateAddBinsTableDataMobile(): void {
		const tempSearch = new MatTableDataSource<any>(this.addBinsTable || []);
		tempSearch.filter = this.tempFilter;
		this.filteredData = tempSearch.filteredData;
		const tableData = [];
		for (let index = this.startIndexTableDataAllBins; index <= this.endIndexTableDataAllBins; index++) {
			if (tempSearch.filteredData[index]) {
				tableData.push(tempSearch.filteredData[index]);
			}
		}
		this.dataSourceAddBinsMobile = tableData.length > 0 ? new MatTableDataSource<any>(tableData) : new MatTableDataSource<any>([]);
		this.dataSourceAddBinsMobile.sort = this.sort;
	}

  private updateTableData(): void {
		const tempSearch = new MatTableDataSource<any>(this.binsDataTable || []);
		tempSearch.filter = this.tempFilter;
		this.filteredBinsToCollectData = tempSearch.filteredData;
		this.dataSource = tempSearch.filteredData.length > 0 ?
			new MatTableDataSource<any>(tempSearch.filteredData) : new MatTableDataSource<any>([]);
		this.dataSource["AllData"] = new MatTableDataSource<any>(tempSearch.filteredData);
		this.dataSource.sort = this.sort;
	}

  private updateTableDataMobile(): void {
		const tempSearch = new MatTableDataSource<any>(this.binsDataTable || []);
		tempSearch.filter = this.tempFilter;
		this.filteredBinsToCollectData = tempSearch.filteredData;
		this.dataSource["AllData"] = new MatTableDataSource<any>(tempSearch.filteredData);
		const tableData = [];
		for (let index = this.startIndexTableData; index <= this.endIndexTableData; index++) {
			if (tempSearch.filteredData[index]) {
				tableData.push(tempSearch.filteredData[index]);
			}
		}
		this.dataSourceMobile = tableData.length > 0 ? new MatTableDataSource<any>(tableData) : new MatTableDataSource<any>([]);
		this.dataSourceMobile.sort = this.sort;
	}

  applyFilter = (filterValue: string) => {
		filterValue = filterValue.trim();
		filterValue = filterValue.toLowerCase();
		this.tempFilter = filterValue;
		this.updateTableData();
		this.updateTableDataMobile();
		this.updateAddBinsTableData();
		this.updateAddBinsTableDataMobile();
	}

  sortAddBinsData(sort: Sort) {
		const data = this.addBinsTable.slice();
		if (!sort.active || sort.direction === '') {
			this.addBinsTable = data;
			this.updateAddBinsTableData();
			this.updateAddBinsTableDataMobile();
			return;
		}
		this.addBinsTable = data.sort((a, b) => {
			const isAsc = sort.direction === 'desc';
			return sort.active ? this.compare(a[sort.active], b[sort.active], isAsc) : 0;
		});
		this.updateAddBinsTableData();
		this.updateAddBinsTableDataMobile();
	}

  sortData(sort: Sort) {
		const data = this.binsDataTable.slice();
		if (!sort.active || sort.direction === '') {
			this.binsDataTable = data;
			this.updateTableData();
			this.updateTableDataMobile();
			return;
		}
		this.binsDataTable = data.sort((a, b) => {
			const isAsc = sort.direction === 'desc';
			return sort.active ? this.compare(a[sort.active], b[sort.active], isAsc) : 0;
		});
		this.updateTableData();
		this.updateTableDataMobile();
	}

	compare(a, b, isAsc) {
		return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
	}

	getDirection(){    
		if(this.currentLang != 'iw'){
		  return 'ltr';
		}
		else{
			return 'rtl';
		  }
	  }

	moveBinToOutside(){
		if(this.selection.selected.length == 0){
			return;
		}else{		
			_.each(this.selection.selected, (b) => {
				this.allBinsForChoose = [...this.allBinsForChoose,b];
			});
			
			let res = this.allBinsToCollect.filter(item1 => 
				!this.selection.selected.some(item2 => (item2["bin_id"] == item1["bin_id"])))			
			this.allBinsToCollect = res;

			this.initializeAddBinsTable();
			this.initializeBinsTable();	
			this.selection.clear();
			this.selectionAddBins.clear();
		}
		this.cd.detectChanges();
	}

	moveBinToInside(){
		if(this.selectionAddBins.selected.length == 0){
			return;
		}else{
			_.each(this.selectionAddBins.selected, (b) => {
				this.allBinsToCollect = [...this.allBinsToCollect,b];	
			});
			let res = this.allBinsForChoose.filter(item1 => 
				!this.selectionAddBins.selected.some(item2 => (item2["bin_id"] == item1["bin_id"])))			
				this.allBinsForChoose = res;

			this.initializeBinsTable();	
			this.initializeAddBinsTable();
			this.selection.clear();
			this.selectionAddBins.clear();
		}
		this.cd.detectChanges();
	}

	private initializeAddBinsTable = () => {
		this.addBinsTable = [];
		const binsFiltered = _.map(this.allBinsForChoose, b => {
			return {
				bin_name: b.bin_name,
				bin_id: b.bin_id,
				bin_address : b.Bin_location ? (b.Bin_location.bin_address ? b.Bin_location.bin_address : '') : (b.bin_address ? b.bin_address : ''),								
				bin_neighborhood : b.Bin_location ? (b.Bin_location.bin_neighbourhood ? b.Bin_location.bin_neighbourhood : '') : (b.bin_neighborhood ? b.bin_neighborhood : ''),				
				bin_status : b.Bin_live_Data ? (b.Bin_live_Data.fill_level_percent ? b.Bin_live_Data.fill_level_percent : 0) : (b.bin_status ? b.bin_status : 0),
				collection_mode : b.Bin_Restrictions ? (b.Bin_Restrictions.collection_mode ? Number(b.Bin_Restrictions.collection_mode) : '') : (b.collection_mode ? Number(b.collection_mode) : 0),	
				predicted_time_for_max_allowed_capacity : b.Bin_live_Data ? (b.Bin_live_Data.predicted_time_for_max_allowed_capacity ? this.utilService.convertDateEnglishWithoutTime(b.Bin_live_Data.predicted_time_for_max_allowed_capacity) : '') : (b.predicted_time_for_max_allowed_capacity ? b.predicted_time_for_max_allowed_capacity : ''),								
				predicted_time_for_max_allowed_capacity_he : b.Bin_live_Data ? (b.Bin_live_Data.predicted_time_for_max_allowed_capacity ? this.utilService.convertDateHebrewWithoutTime(b.Bin_live_Data.predicted_time_for_max_allowed_capacity) : '') : (b.predicted_time_for_max_allowed_capacity_he ? b.predicted_time_for_max_allowed_capacity_he : ''),								
				predicted_time_for_max_allowed_capacity_value : moment(b.Bin_live_Data ? (b.Bin_live_Data.predicted_time_for_max_allowed_capacity ? this.utilService.convertDateEnglishWithoutTime(b.Bin_live_Data.predicted_time_for_max_allowed_capacity) : '') : (b.predicted_time_for_max_allowed_capacity ? b.predicted_time_for_max_allowed_capacity : '')).format("YYYY-MM-DD HH:mm:ss").valueOf(),
			};
		});
		this.binsDataAddBins = binsFiltered;	

		_.each(this.binsDataAddBins, (item) => {			
			this.addBinsTable.push(item);			
		});	
		this.sortAddBinsData({ direction: 'desc', active: 'bin_name' });
		this.updateAddBinsTableData();
		this.updateAddBinsTableDataMobile();
		this.dataSourceAddBins.sort = this.sort;
		if (this.dataSourceAddBinsMobile) {
			this.dataSourceAddBinsMobile.sort = this.sort;
		}
	}

	initializeBinsTable = () => {
		this.binsDataTable = [];
		const binsFiltered = _.map(this.allBinsToCollect, b => {
			return {
				bin_name: b.bin_name,
				bin_id: b.bin_id,
				bin_address : b.Bin_location ? (b.Bin_location.bin_address ? b.Bin_location.bin_address : '') : (b.bin_address ? b.bin_address : ''),								
				bin_neighborhood : b.Bin_location ? (b.Bin_location.bin_neighbourhood ? b.Bin_location.bin_neighbourhood : '') : (b.bin_neighborhood ? b.bin_neighborhood : ''),				
				bin_status : b.Bin_live_Data ? (b.Bin_live_Data.fill_level_percent ? b.Bin_live_Data.fill_level_percent : 0) : (b.bin_status ? b.bin_status : 0),
				collection_mode : b.Bin_Restrictions ? (b.Bin_Restrictions.collection_mode ? Number(b.Bin_Restrictions.collection_mode) : '') : (b.collection_mode ? Number(b.collection_mode) : 0),
				predicted_time_for_max_allowed_capacity : b.Bin_live_Data ? (b.Bin_live_Data.predicted_time_for_max_allowed_capacity ? this.utilService.convertDateEnglishWithoutTime(b.Bin_live_Data.predicted_time_for_max_allowed_capacity) : '') : (b.predicted_time_for_max_allowed_capacity ? b.predicted_time_for_max_allowed_capacity : ''),								
				predicted_time_for_max_allowed_capacity_he : b.Bin_live_Data ? (b.Bin_live_Data.predicted_time_for_max_allowed_capacity ? this.utilService.convertDateHebrewWithoutTime(b.Bin_live_Data.predicted_time_for_max_allowed_capacity) : '') : (b.predicted_time_for_max_allowed_capacity_he ? b.predicted_time_for_max_allowed_capacity_he : ''),								
				predicted_time_for_max_allowed_capacity_value : moment(b.Bin_live_Data ? (b.Bin_live_Data.predicted_time_for_max_allowed_capacity ? this.utilService.convertDateEnglishWithoutTime(b.Bin_live_Data.predicted_time_for_max_allowed_capacity) : '') : (b.predicted_time_for_max_allowed_capacity ? b.predicted_time_for_max_allowed_capacity : '')).format("YYYY-MM-DD HH:mm:ss").valueOf(),
			};
		});
		this.binsData = binsFiltered;	
		
		_.each(this.binsData, (item) => {			
			this.binsDataTable.push(item);			
		});			
		this.sortData({ direction: 'desc', active: 'bin_name' });
		this.updateTableData();
		this.updateTableDataMobile();
		this.dataSource.sort = this.sort;
		if (this.dataSourceMobile) {
			this.dataSourceMobile.sort = this.sort;
		}
	}

	applyChanges(){
		if(this.ElForm.getRawValue()['siteName'] == ''){
			return;
		}
		this.removeBinFromWorkplan();
		this.addBinsToWorkplan();
		this.closeModal();
	}

	getImg(value:any){			
		if(value == 2){
			return "assets/images/dashboard/selected.svg";
		}else{
			return "assets/images/dashboard/notSelected.svg";
		}
	}

	public removeBinFromWorkplan = () => {			
		let includedBins = this.allBinsToCollectBackUp.filter(item1 => 
			!this.allBinsToCollect.some(item2 => (item2["bin_id"] == item1["bin_id"])))		

		const binsToAdd: any = includedBins;
		if (_.isEmpty(binsToAdd)) return;
		const binListId = _.map(binsToAdd, 'bin_id');		
		const dataToSend = {
			bin_id_list: binListId,
			site_id:includedBins[0]['site_id']
		};

		this.apiService.cancelForceBinsToWorkPlan(dataToSend).subscribe((v:any) => { 			
			let userGeneratedWorkplans = {
				site_id:0
			}	
			let start_date = moment().subtract(11, 'months').format('YYYY-MM-DD HH:MM:59');
			let end_date = moment().format('YYYY-MM-DD HH:MM:59');
			this.apiStore.update({ allFilteredDailyWorkPlan: [] });
			this.apiStore.update({ filteredDailyWorkPlan: [] });
			this.apiService.getfilteredActivePlans(JSON.parse(sessionStorage.getItem("chosenSites"))); 
			this.apiStore.update({ allWorkPlanScheduler: [] });
			this.apiStore.update({ workPlanScheduler: [] });
			this.apiService.getfilteredWorkPlanScheduler(userGeneratedWorkplans,JSON.parse(sessionStorage.getItem("chosenSites")));
			this.apiStore.update({ allDailyWorkPlanCalanderData: [] });
			this.apiStore.update({ dailyWorkPlanCalanderData: [] });
			this.apiService.getDailyWorkPlanCalanderData(start_date,end_date,this.is_view_unexecuted_work_plans,JSON.parse(sessionStorage.getItem("chosenSites")));  	
			this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));		
		});   
	}

	public addBinsToWorkplan = () => {
		let includedBins = this.allBinsForChooseBackUp.filter(item1 => 
			!this.allBinsForChoose.some(item2 => (item2["bin_id"] == item1["bin_id"])));

		const binsToAdd: any = includedBins;
		if (_.isEmpty(binsToAdd)) return;
		const binListId = _.map(binsToAdd, 'bin_id');		
		const dataToSend = {
			bin_id_list: binListId,
			site_id:includedBins[0]['site_id']
		};
		this.apiService.forceBinsToWorkPlan(dataToSend).subscribe((v:any) => {     
			let userGeneratedWorkplans = {
				site_id:0
			}	
			let start_date = moment().subtract(11, 'months').format('YYYY-MM-DD HH:MM:59');
			let end_date = moment().format('YYYY-MM-DD HH:MM:59');
			this.apiStore.update({ allFilteredDailyWorkPlan: [] });
			this.apiStore.update({ filteredDailyWorkPlan: [] });
			this.apiService.getfilteredActivePlans(JSON.parse(sessionStorage.getItem("chosenSites"))); 
			this.apiStore.update({ allWorkPlanScheduler: [] });
			this.apiStore.update({ workPlanScheduler: [] });
			this.apiService.getfilteredWorkPlanScheduler(userGeneratedWorkplans,JSON.parse(sessionStorage.getItem("chosenSites")));
			this.apiStore.update({ allDailyWorkPlanCalanderData: [] });
			this.apiStore.update({ dailyWorkPlanCalanderData: [] });
			this.apiService.getDailyWorkPlanCalanderData(start_date,end_date,this.is_view_unexecuted_work_plans,JSON.parse(sessionStorage.getItem("chosenSites")));  								
			this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites"))); 			 		
		});   
	}
}
